<template>
	<div>
		<iframe
			v-bind:id="'thumbnail'+dir"
			class="thumbnail"
			:alt="dir"
		/>
		<p v-if="invoice_id!=undefined" class="subtext">{{invoice_id}}</p>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        dir: String,
		id: {
			type: Number,
			required: false,
			default: -1
		},
		invoice_id: String,
    },
	data() {
		return {

		}
	},
	mounted () {
		let stateCheck = setInterval(() => {
			if (document.getElementById("thumbnail"+this.dir)!=null) {
				clearInterval(stateCheck);
				this.setInvoice();
			}
		}, 100);
	},
	methods:{
		setInvoice(){
			api.getInvoice(
                {
                    data:{
						filename:this.dir
					}
                }
            ).then((res) => {
				if(res.data!=''){
					var embed = document.getElementById("thumbnail"+this.dir);

					var base64 = res.data
					var type = 'application/pdf'

					var binStr = atob( base64 );
					var len = binStr.length;
					var arr = new Uint8Array(len);
					for (let i = 0; i < len; i++) {
						arr[ i ] = binStr.charCodeAt( i );
					}
					var blob = new Blob( [ arr ], { type: type } );

					embed.src = URL.createObjectURL(blob)
				}
	        });
		},
	},
	watch:{
		dir(){
			this.setInvoice();
		},
		id(){
			this.setInvoice();
		},
		invoice_id(){
			this.setInvoice();
		},
	},
}
</script>

<style scoped>
.subtext{
	font-size: 12px;
	font-weight: normal;
	display:flex;
	flex-wrap: wrap;
	justify-content:left;
}

.thumbnail{
	width:100%;
	height:100%;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 5px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/invoice.vue